import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';
import { FeatureCardComponent } from '../../ui/feature-card/feature-card.component';

@Component({
  selector: 'app-quiz-prep',
  standalone: true,
  imports: [SectionHeadingComponent, FeatureCardComponent],
  templateUrl: './quiz-prep.component.html',
  styleUrl: './quiz-prep.component.scss',
})
export class QuizPrepComponent {
  questions = [
    {
      q: 'Gdzie para młoda poznała się po raz pierwszy?',
      a: 'Na imprezce u znajomych · W pracy · Na aplikacji randkowej · Na obozie',
    },
    {
      q: 'Kto pierwszy powiedział „kocham Cię"?',
      a: 'Pan Młody · Panna Młoda · Powiedzieli jednocześnie · Żadne z nich jeszcze nie powiedziało',
    },
    {
      q: 'Co Pan Młody robi, gdy przegra zakład?',
      a: 'Udaje że wygrał · Milczy tydzień · Śmieje się i przyznaje · Obwinia sędziego',
    },
    {
      q: 'Który film oglądali razem jako pierwszy na randce?',
      a: 'Horror · Romans · Komedia · Dokument o pingwinach',
    },
  ];
}
